<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ 'fee.apply_discount' | translate }}</h2>
    <button class="close-btn" type="button" (click)="cancel()" [attr.aria-label]="'common.close_dialog' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()" class="dialog-form">
    <div class="discount-grid">
      <mat-form-field appearance="fill" class="discount-type-field">
        <mat-select formControlName="discountType"
                    (openedChange)="onDiscountSelectOpened($event)">
          <mat-select-trigger>
            {{ discountTypeSymbol(form.get('discountType')!.value) }}
          </mat-select-trigger>
          @for (type of discountTypes; track type) {
            <mat-option [value]="type" (click)="onDiscountTypeOptionClick(type)">
              {{ discountTypeSymbol(type) }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="discount-value-cell">
        <mat-form-field appearance="fill" class="discount-value-field">
          <input matInput type="number" formControlName="discountValue" min="0" class="no-spinner"
                 inputmode="numeric" (keydown)="onDiscountKeyDown($event)" (paste)="onDiscountPaste($event)"
                 [placeholder]="'fee.discount_optional' | translate" />
        </mat-form-field>
        <div class="discount-error-stack">
          @if (form.get('discountType')!.hasError('discountTypeRequired')) {
            <mat-error>{{ 'fee.validation.discount_type_required' | translate }}</mat-error>
          }
          @if (form.get('discountValue')!.hasError('notInteger')) {
            <mat-error>{{ 'fee.validation.discount_whole_number' | translate }}</mat-error>
          }
          @if (form.get('discountValue')!.hasError('maxPercent')) {
            <mat-error>{{ 'fee.validation.discount_percent_max' | translate }}</mat-error>
          }
          @if (form.get('discountValue')!.hasError('exceedsPrice')) {
            <mat-error>{{ 'fee.validation.discount_less_than_price' | translate }}</mat-error>
          }
        </div>
      </div>

      <div class="price-summary">
        <span class="price-label">{{ 'fee.price' | translate }} - {{ basePrice | number:'1.0-0' }} ֏</span>
        <span class="final-price-label">{{ 'fee.final_price' | translate }} - {{ finalPrice | number:'1.0-0' }} ֏</span>
      </div>
    </div>

    <mat-form-field appearance="fill" class="discount-reason-field">
      <input matInput formControlName="discountReason" maxlength="100"
             [placeholder]="'fee.discount_reason_optional' | translate" />
      @if (form.get('discountReason')!.hasError('maxlength')) {
        <mat-error>{{ 'fee.validation.max_100_characters' | translate }}</mat-error>
      }
    </mat-form-field>

    <div class="dialog-actions">
      <button type="button" class="btn-cancel" (click)="cancel()">{{ 'Cancel' | translate }}</button>
      <button type="submit" class="btn-save" [disabled]="submitting">
        @if (submitting) {
          <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
        } @else {
          {{ 'user_card.save' | translate }}
        }
      </button>
    </div>
  </form>
</div>
